import { Component, OnInit, ViewChild, DebugNode, Inject } from '@angular/core';
import { DocumentUploadMasterService } from './documentuploadmaster.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { global } from '../../shared/global';
import { Router, ActivatedRoute } from "@angular/router";
import { DocumentUpload } from '../Models/documentupload.model';
import { DOCUMENT } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-documentuploadmaster',
  templateUrl: './documentuploadmaster.component.html',
  styleUrls: ['./documentuploadmaster.component.css']
})
export class DocumentuploadmasterComponent implements OnInit {
  @ViewChild('documentUpload') documentUpload: NgForm;
  data: DocumentUpload;
  dropDownData: any;
  responseData: any;
  documentUploadList: Array<any>;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  submitted: boolean;
  searchtext: any;
  HashCode: any;
  btnsubmittext = "Add";
  totalPages = 10;
  totalDocument : any;
  constructor(private service: DocumentUploadMasterService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    if (localStorage.length == 0) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    this.data = new DocumentUpload();
    $("#searchtext").val("");
    this.getDocumentUploadList(this.p);
    document.getElementById('YearID').addEventListener('change', () => {
      this.getDocumentUploadList(this.p);
    });
  }
  getDocumentUploadList(page) {
    this.spinner.show();
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit,
      YearID : localStorage.getItem("YearID")
    };
    this.service.getDocumentUploadList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.documentUploadList = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
         // this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.show();
          this.documentUploadList = this.responseData.documentUploadLists;
          //this.totalPages = this.responseData.totalPages;
          this.totalDocument = this.responseData.totalCount;
          this.spinner.hide();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  onSubmit(data) {
    this.submitted = true;
    if (this.documentUpload.valid) {
      this.spinner.show();
      this.data.YearID = Number(localStorage.getItem("YearID"));
      this.service.saveDocumentUpload(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
           // this.router.navigate(['/aciadmin']);
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.getDocumentUploadList(this.p);
            this.toastr.success(this.responseData.message);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }

  editDocumentUpload(HashCode) {
    this.spinner.show();
    const data = {
      HashCode: HashCode,
      YearID : localStorage.getItem("YearID")
    };
    this.service.getDocumentUploadByID(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.data = this.responseData;
          this.btnsubmittext = "Update";
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }
  deleteDocumentUpload(HashCode) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode
      }
      this.spinner.show();
      this.service.deleteDocumentUpload(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
            return
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
          //  this.router.navigate(['/aciadmin']);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.getDocumentUploadList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.documentUploadList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  resetForm() {
    this.data.ID = 0;
    this.data.HashCode = null;
    this.data.DocumentName = null;
    this.submitted = false;
    this.btnsubmittext = "Add";
  }
}
